import { Link } from "react-router-dom";
import {
  Building2,
  Cpu,
  FileText,
  Users,
  Banknote,
  Microscope,
  Sparkles,
} from "lucide-react";

interface TutorialCard {
  titulo: string;
  resumen: string;
  icon: React.ReactNode;
  to?: string;
  externo?: string;
  proximamente?: boolean;
  audiencia: "Externo" | "Interno" | "Mixto";
}

const TUTORIALES: TutorialCard[] = [
  {
    titulo: "Registro Legal",
    resumen:
      "Cómo dar de alta tu empresa: datos jurídicos, documentos requeridos, validación por Calidad y carta poder cuando aplica.",
    icon: <Building2 className="h-5 w-5" />,
    to: "/ayuda/registro-legal",
    audiencia: "Externo",
  },
  {
    titulo: "Telecomunicaciones",
    resumen:
      "Captura de solicitudes Telecom, esquemas (1/2/3/CU), normas, laboratorios y reportes de pruebas. Seguimiento del flujo.",
    icon: <Cpu className="h-5 w-5" />,
    proximamente: true,
    audiencia: "Externo",
  },
  {
    titulo: "Certificados",
    resumen:
      "Generación del certificado: numeración, modalidades CON/SIN relación, especificaciones técnicas por norma y fracciones arancelarias.",
    icon: <FileText className="h-5 w-5" />,
    proximamente: true,
    audiencia: "Mixto",
  },
  {
    titulo: "Usuarios internos NPMX",
    resumen:
      "Alta de personal interno, asignación de roles (Calidad, Telecom, Coordinación, Evaluadores), permisos y bandejas.",
    icon: <Users className="h-5 w-5" />,
    proximamente: true,
    audiencia: "Interno",
  },
  {
    titulo: "Finanzas / Facturación",
    resumen:
      "Validación de pagos, generación de referencia, ciclo Solicitud → Facturación → Evaluación.",
    icon: <Banknote className="h-5 w-5" />,
    proximamente: true,
    audiencia: "Interno",
  },
  {
    titulo: "Evaluación y Revisión",
    resumen:
      "Bandeja del evaluador técnico, revisión por coordinador, observaciones, devoluciones y toma de decisión.",
    icon: <Microscope className="h-5 w-5" />,
    proximamente: true,
    audiencia: "Interno",
  },
];

export function AyudaTutorialesTab() {
  return (
    <div className="space-y-4">
      <section className="rounded-lg border bg-surface p-5 shadow-card">
        <h2 className="text-base font-semibold text-fg">Tutoriales por módulo</h2>
        <p className="mt-1 text-sm text-fg-muted">
          Selecciona el módulo sobre el que quieres aprender. Algunos tutoriales todavía
          están en preparación; los que ya están disponibles abren la guía completa.
        </p>
      </section>

      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {TUTORIALES.map((t) => (
          <article
            key={t.titulo}
            className="flex flex-col rounded-lg border bg-surface p-4 shadow-card"
          >
            <div className="flex items-start justify-between gap-2">
              <span className="grid h-9 w-9 place-items-center rounded-md bg-primary-tint text-primary-strong">
                {t.icon}
              </span>
              <span
                className={`rounded-full px-2 py-0.5 text-[10px] font-medium ${
                  t.audiencia === "Externo"
                    ? "bg-estado-info-bg text-estado-info"
                    : t.audiencia === "Interno"
                      ? "bg-estado-warn-bg text-estado-warn"
                      : "bg-estado-ok-bg text-estado-ok"
                }`}
              >
                {t.audiencia}
              </span>
            </div>
            <h3 className="mt-3 text-sm font-semibold text-fg">{t.titulo}</h3>
            <p className="mt-1 flex-1 text-xs text-fg-muted">{t.resumen}</p>
            <div className="mt-3">
              {t.proximamente ? (
                <span className="inline-flex items-center gap-1 rounded border border-edge px-2.5 py-1 text-[11px] font-medium text-fg-subtle">
                  <Sparkles className="h-3 w-3" /> Próximamente
                </span>
              ) : t.to ? (
                <Link
                  to={t.to}
                  className="inline-flex items-center rounded border border-primary-strong px-2.5 py-1 text-xs font-medium text-primary-strong transition hover:bg-primary-tint"
                >
                  Ver tutorial
                </Link>
              ) : t.externo ? (
                <a
                  href={t.externo}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center rounded border border-primary-strong px-2.5 py-1 text-xs font-medium text-primary-strong transition hover:bg-primary-tint"
                >
                  Abrir
                </a>
              ) : null}
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
